import React, { useContext, useMemo } from "react";
import { ElementState, Preview } from "@creatomate/preview";
import { MillisecondsField } from "@culturehq/components";
import { MillisecondsFieldValue } from "@culturehq/components/dist/components/form/MillisecondsField";
import { Trans } from "app/utils";
import { CreatomateContext } from "../../contexts/VideoStudioContext";

interface VideoSpeedProps {
  activeElement: ElementState;
  preview: Preview;
}

const VideoSpeed: React.FC<VideoSpeedProps> = ({ activeElement, preview }) => {
  const { handleUpdateData } = useContext(CreatomateContext);

  const currentSpeed = useMemo(() => {
    const speedValue = activeElement?.source?.speed
      ? parseInt(activeElement.source.speed.replace("%", ""), 10)
      : 100;
    return speedValue / 100;
  }, [activeElement.source.speed]);

  const handleSpeedChange = async (value: MillisecondsFieldValue) => {
    if (value && value >= 50 && value <= 200) {
      await preview.applyModifications({
        [`${activeElement.source.id}.speed`]: value,
        [`${activeElement.source.id}.duration`]: (activeElement.source.duration * currentSpeed) / (value / 100)
      });
      handleUpdateData({ blockSubtitles: true });
    }
  };

  const getSpeedValue = (): number => {
    if (!activeElement?.source?.speed) return 100;
    return parseInt(activeElement.source.speed.replace("%", ""), 10);
  };

  return (
    <MillisecondsField
      className="chq-ffd-border"
      min={0.5}
      max={2}
      name="speed"
      onChange={handleSpeedChange}
      value={getSpeedValue()}
    >
      <Trans>Video Speed</Trans>
    </MillisecondsField>
  );
};

export default VideoSpeed;
